import { render, staticRenderFns } from "./CommunityPost.vue?vue&type=template&id=a21de64e&scoped=true&"
import script from "./CommunityPost.vue?vue&type=script&lang=js&"
export * from "./CommunityPost.vue?vue&type=script&lang=js&"
import style0 from "./CommunityPost.vue?vue&type=style&index=0&id=a21de64e&scoped=true&lang=sass&"
import style1 from "./CommunityPost.vue?vue&type=style&index=1&id=a21de64e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21de64e",
  null
  
)

export default component.exports